import React, { FC } from 'react';
import classNames from 'classnames';
import Tooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import { addSeparatorBetweenElements } from '../../utils/jsxUtils';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import styles from './decision_header_subtitle.module.scss';

type Props = {
  source: string;
  arretDecAtt?: Array<string> | null;
  solution?: string;
  validation?: {
    url: string;
    validated: boolean;
    ofJuridiction: string;
    juridiction: string;
    solution?: string;
  };
  docId: string;
  automaticMetadata?: { [s: string]: string };
};

export const DecisionHeaderSubtitle: FC<Props> = ({
  arretDecAtt,
  solution,
  validation,
  docId,
  automaticMetadata,
  source,
}) => {
  let id = 0;
  const tags = [];
  if (arretDecAtt) {
    tags.push(
      <SimpleTag
        key={(id += 1)}
        label="Décision attaquée"
        value={arretDecAtt.join(' ')}
      />,
    );
  }
  if (solution) {
    tags.push(
      <SimpleTag key={(id += 1)} label="Dispositif" value={solution} />,
    );
  }
  if (validation) {
    tags.push(
      <span key={(id += 1)}>
        <span>{validation.juridiction}</span>
        {`\u00a0`}
        <FormattedMessage id="decision/header/DecisionHeaderSubtitle.tsx/1" />
        {`\u00a0`}
        <Hyperlink
          href={buildUrlWithParameters(validation.url, {
            source: `${source}_validation`,
          })}
          className={classNames(
            'has-tip',
            validation.validated && styles.validated,
            !validation.validated && styles.notValidated,
          )}
          data-tip={`Lire la décision ${validation.ofJuridiction}`}
          data-for={`validation-${docId}`}
        >
          {validation.solution}
        </Hyperlink>
        <Tooltip id={`validation-${docId}`} effect="solid" />
      </span>,
    );
  }
  if (automaticMetadata) {
    Object.keys(automaticMetadata).forEach(key => {
      tags.push(
        <SimpleTag
          key={(id += 1)}
          label={key}
          value={automaticMetadata[key]}
        />,
      );
    });
  }

  return (
    <>
      <div className={styles.container}>
        {addSeparatorBetweenElements(
          tags,
          <span className={styles.separator}>
            {' '}
            <FormattedMessage id="decision/header/DecisionHeaderSubtitle.tsx/2" />
          </span>,
        )}
      </div>
    </>
  );
};

const SimpleTag: FC<{ label: string; value: string }> = ({ label, value }) => (
  <span>
    <span>{`${label}\u00a0:\u00a0`}</span>
    <span dangerouslySetInnerHTML={{ __html: value }} />
  </span>
);
